module.exports = __webpack_public_path__ + "pc/img/spotImg.ce636952.png";